import { Form, Row, Col, Button, Table, Modal, InputGroup} from "react-bootstrap";
import { BsFillXCircleFill } from "react-icons/bs";
import { FaWhatsapp } from "react-icons/fa6";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import BreadcrumbPedidos from "./BreadcrumbPedidos";
import ErrorMessages from "../common/ErrorMessages";
import MaoBuscador from "../common/MaoBuscador";
import { getClientes, getCliente } from "../../services/ClientesService";
import { getMarcas } from "../../services/MarcasService";
import { getProductos } from "../../services/ProductosService";
import { nuevoPedido, getPedido, editarPedido } from "../../services/PedidosService";
import { formatNumber } from "../../utils/NumberUtils";
import { Cargando } from "../common/Cargando";
import { validUuid } from "../../utils/UuidUtils";

const api_pdf = process.env.REACT_APP_HOME_URL+"/pedidos/pdf/";

export default function PedidosForm() {

    /*
    https://react-hook-form.com/docs/usefieldarray
    https://react-bootstrap.netlify.app/docs/components/modal
    */

    const navigate = useNavigate();

    const {id} = useParams();

    const [params] = useSearchParams();

    const [errores, setErrores] = useState([]);

    const [cargando, setCargando] = useState(true);

    const { register, control, handleSubmit, setValue, getValues, formState: { errors }, reset } = useForm();

    const { fields, append, remove, update } = useFieldArray({
        control,
        name: "detalles"
      });

    const [marcas, setMarcas] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [productos, setProductos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [estadoInicial, setEstadoInicial] = useState("");
    const [filtroProducto, setFiltroProducto] = useState("");
    const [showModalGuardar, setShowModalGuardar] = useState({
        showModal: false,
        mensaje: "",
        estado: undefined,
        uuid: undefined,
        cliente_id: undefined
    });

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const handleCloseGuardar = () => {
        setShowModalGuardar({
            showModal: false,
            mensaje: "",
            estado: undefined,
            uuid: undefined,
            cliente_id: undefined
        });
        volver();
    }

    useEffect(() => {
        async function buscarClientes() {
            let resp = await getClientes();
            if (resp.error) {
                //setError(resp.message);
                setClientes([]);
            } else {
                //setError("");
                setClientes(resp.data);
            }
        }
        buscarClientes();
    }, []);

    useEffect(() => {
        async function initMarcas() {
            let resp = await getMarcas();
            if (resp.error) {
                //setError(resp.message);
                setMarcas([]);
            } else {
                //setError("");
                setMarcas(resp.data);
                if (id) {
                    iniciarEdicion();
                }
                setCargando(false);
            }
        }
        initMarcas();
    }, []);

    //useEffect(() => {
        const iniciarEdicion = async () => {
            let resp = await getPedido(id);
            if (resp.error) {
                setErrores([resp.message]);
            } else {
                reset(resp.data);
                setEstadoInicial(getValues('estado'));
                actualizarProductos(resp.data.marca_id);
            }
        }
    /*    if (id) {
            iniciarEdicion();
        }
    }, [id,reset])*/

    function volver() {
        let consulta = params.get('consulta');
        navigate("/pedidos"+(consulta?'/consulta':''));
    }

    function cancelar() {
        if (window.confirm("¿Está seguro que desea cancelar el pedido?")) {
            volver();
        }
    }

    function beforeSubmit(event) {
        if (event.target.id==='btnFinalizar') {
            setValue('estado','F');
        }
        setErrores([]);
    }

    function descargar(uuid) {
        if (validUuid(uuid)) {
            window.open(api_pdf+uuid, '_blank'); 
        }
        volver();
    }

    async function avisarPorTelefono(uuid, cliente_id) {
        setCargando(true);
        let respCli = await getCliente(cliente_id);
        setCargando(false);
        console.log(respCli);
        if (respCli.error) {
            console.error(respCli.messages);
            alert("Hubo un error al intentar avisar por whatsapp");
        } else {
            if (respCli.data.telefono == '') {
                alert("No hay registrado un teléfono para el cliente");
            } else {
                let text = "Se%20ha%20generado%20un%20pedido%20con%20Grupo%20Carrabs,%20haga%20click%20en%20el%20siguiente%20link%20para%20descargar%20el%20mismo:%20"+api_pdf+uuid;
                //window.open("https://api.whatsapp.com/send?phone=5493416012648&text=Hola,%20visita%20nuestro%20sitio:%20https://example.com", '_blank');
                //window.open("https://api.whatsapp.com/send?phone="+respCli.data.telefono+"&text=Hola,%20visita%20nuestro%20sitio:%20https://grupocarrabs.com.ar/api/pedidos/pdf/"+uuid, '_blank');
                window.open("https://api.whatsapp.com/send?phone="+respCli.data.telefono+"&text="+text, '_blank');
            }
        }
        volver();
    }

    const onSubmit = async (data) => {
        setCargando(true);
        console.log(data);
        //otras validaciones
        if (data.detalles.length===0) {
            setErrores(["Debe agregar al menos un producto."]);
            setCargando(false);
            return;
        }
        let resp;
        if (id) {
            resp = await editarPedido(id, data);
        } else {
            resp = await nuevoPedido(data);
        }
        setCargando(false);
        if (resp.error) {
            setErrores(resp.messages);
            window.scrollTo(0,0);
        } else {
            //descargar(resp.data.pedido_uuid);
            setShowModalGuardar({
                showModal: true,
                mensaje: `Pedido ${(data.estado==='F' && data.estado!==estadoInicial)?'finalizado':'guardado'} correctamente`,
                estado: resp.data.estado,
                uuid: resp.data.pedido_uuid,
                cliente_id: resp.data.cliente_id
            })
            //alert(`Pedido ${(data.estado==='F' && data.estado!==estadoInicial)?'finalizado':'guardado'} correctamente`);
            //volver();
        }
    }

    async function actualizarComisionYDescuentos(marca_id) {
        let marca = marcas.find(m => m.marca_id === marca_id);
        if (marca) {
            setValue('comision_porc',marca.comision);
            if (marca.descuento1)
                setValue('descuento1_porc',marca.descuento1);
            if (marca.descuento2)
                setValue('descuento2_porc',marca.descuento2);
            if (marca.descuento3)
                setValue('descuento3_porc',marca.descuento3);
        }
    }

    async function actualizarProductos(marca_id) {
        if (marca_id && marca_id !== '') {
            let resp = await getProductos(marca_id);
            if (resp.error) {
                //setError(resp.message);
                setProductos([]);
            } else {
                //setError("");
                let detalles = getValues('detalles');
                let productosNew = resp.data.map((p) => {
                    let selected = false;
                    for(let d of detalles) {
                        if (d.producto_id === p.producto_id) {
                            selected = true;
                            break;
                        }
                    }
                    p.cantidad_selected = p.cantidad_x_bulto;
                    p.selected = selected;
                    p.visible = !selected;
                    return p;
                });
                setProductos(productosNew);
            }
        }
    }

    const actualizarSubtotal = (cant, index) => {
        let item = getValues('detalles')[index];
        item.subtotal = item.precio_unitario * cant;
        update(index, item);
        calcularTotales();
    }

    const updateItemToUpdateTotals = () => {
        if (getValues('detalles').length>0) {
            let item = getValues('detalles')[0];
            update(0, item);
            calcularTotales();
        }
    }

    const calcularTotales = () => {
        let subtotal = 0;
        getValues('detalles').map((p,index) => {
            subtotal += p.precio_unitario * p.cantidad;
        })
        setValue('total_sin_desc',subtotal);
        let descuento_porc = 1;
        let descuento = 0;
        let descuento1_porc = getValues('descuento1_porc');
        if (descuento1_porc && descuento1_porc>0) {
            descuento_porc *= 1 - (parseFloat(descuento1_porc) / 100);
        }
        let descuento2_porc = getValues('descuento2_porc');
        if (descuento2_porc && descuento2_porc>0) {
            //descuento_porc += parseFloat(descuento2_porc);
            descuento_porc *= 1 - (parseFloat(descuento2_porc) / 100);
        }
        let descuento3_porc = getValues('descuento3_porc');
        if (descuento3_porc && descuento3_porc>0) {
            //descuento_porc += parseFloat(descuento3_porc);
            descuento_porc *= 1 - (parseFloat(descuento3_porc) / 100);
        }
        if (descuento_porc<1) {
            descuento = parseFloat(subtotal * (1 - descuento_porc));
        }
        setValue('descuento',descuento);
        let total = subtotal - descuento;
        let comision = 0;
        let comision_porc = getValues('comision_porc');
        if (comision_porc>0) {
            comision = parseFloat(total * comision_porc / 100);
        }
        setValue('comision',comision);
        setValue('total',total);
    }

    const seleccionarProductos = () => {
        let marca_id = getValues('marca_id');
        if (marca_id && marca_id !== '') {
            setFiltroProducto("");
            handleShow();
        } else {
            alert("Debe seleccionar una marca primero");
        }
    };

    const selectProducto = (index, selected) => {
        productos[index].selected = selected;
        let productosNew = productos.slice(0);
        setProductos(productosNew);
    }
    const selectProductoById = (id, selected) => {
        console.log(id);
        let p = productos.find((p) => p.codigo === id);
        console.log(p);
        p.selected = selected;
        let productosNew = productos.slice(0);
        setProductos(productosNew);
    }
    const selectProductoYCantidadById = (id, cantidad) => {
        let p = productos.find((p) => p.codigo === id);
        p.selected = parseInt(cantidad)>0?true:false;
        p.cantidad_selected = parseInt(cantidad);
        let productosNew = productos.slice(0);
        setProductos(productosNew);
    }

    const selectProductoYPrecioUnitarioById = (id, precio) => {
        let p = productos.find((p) => p.codigo === id);
        p.selected = parseFloat(precio)>0?true:false;
        p.precio_unitario = parseFloat(precio);
        let productosNew = productos.slice(0);
        setProductos(productosNew);
    }

    const aceptarSeleccion = () => {
        productos.map((p) => {
            if (p.selected) {
                //busco si ya fue agregado
                let detalles = getValues('detalles');
                let index = detalles.findIndex(d => d.producto_id === p.producto_id);
                if (index === -1) {
                    append({
                        producto_id: p.producto_id,
                        producto: p.codigo + " - " + p.descripcion, 
                        precio_x_bulto: p.precio_x_bulto, 
                        precio_unitario: p.precio_unitario,
                        //cantidad: p.cantidad_x_bulto,
                        cantidad: p.cantidad_selected,
                        cantidad_x_bulto: p.cantidad_x_bulto,
                        //subtotal: p.precio_x_bulto 
                        subtotal: p.cantidad_selected * p.precio_unitario
                    });
                    p.visible = false;
                }
            } else {
                //busco si está para quitarlo
                let detalles = getValues('detalles');
                let index = detalles.findIndex(d => d.producto_id === p.producto_id);
                if (index > -1) {
                    remove(index);
                }
            }
        })
        calcularTotales();
        handleClose();
    }

    const hacerVisible = (id) => {
        productos.map((p) => {
            if (p.producto_id === id) {
                p.selected = false;
                p.visible = true;
                p.cantidad_selected = p.cantidad_x_bulto;
            }
        })
        let productosNew = productos.slice(0);
        setProductos(productosNew);
    }

    const agregarTodos = () => {
        let marca_id = getValues('marca_id');
        if (marca_id && marca_id !== '') {
            productos.map((p) => {
                //busco si ya fue agregado
                let detalles = getValues('detalles');
                let index = detalles.findIndex(d => d.producto_id === p.producto_id);
                if (index === -1) {
                    append({
                        producto_id: p.producto_id,
                        producto: p.codigo + " - " + p.descripcion, 
                        precio_x_bulto: p.precio_x_bulto, 
                        precio_unitario: p.precio_unitario,
                        cantidad: p.cantidad_x_bulto,
                        cantidad_x_bulto: p.cantidad_x_bulto,
                        subtotal: p.precio_x_bulto 
                    });
                    p.visible = false;
                }
            })
            calcularTotales();
        } else {
            alert("Debe seleccionar una marca primero");
        }
    }

    return <>
        <BreadcrumbPedidos active={getValues('pedido_id')?"Pedidos - Edición":"Pedidos - Nuevo"} />
        <ErrorMessages mensajes={errores} />
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column xs="2">
                    Número
                </Form.Label>
                <Col xs="3">
                    <Form.Control 
                        id="numero" 
                        {...register("numero")}
                        type="number" htmlSize="11" 
                        disabled={true}/>
                </Col>
                <Form.Label column xs="2">
                    Fecha
                </Form.Label>
                <Col xs="5" sm="3">
                    <Form.Control 
                        id="fecha" 
                        {...register("fecha", {required:true})}
                        type="date"/>
                </Col>
                {errors.fecha?.type === 'required' && <Col className="validacion error"><p role="alert">Fecha es requerida.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Marca
                </Form.Label>
                <Col sm="8">
                    <Form.Select 
                        id="marca_id" 
                        disabled={getValues('pedido_id')}
                        {...register("marca_id", {
                            onChange: (e) => {
                                actualizarComisionYDescuentos(e.target.value);
                                actualizarProductos(e.target.value);
                                remove();//para quitar todos los detalles
                            },
                            required:true
                        })}>
                        <option value="">Seleccione marca...</option>
                        {marcas.map((m) => <option key={m.marca_id} value={m.marca_id}>{m.nombre}</option>)}
                    </Form.Select>
                </Col>
                {errors.marca_id?.type === 'required' && <Col className="validacion error"><p role="alert">Marca es requerida.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Cliente
                </Form.Label>
                <Col sm="8">
                    <MaoBuscador 
                        placeholder="Busque un cliente..."
                        datos={clientes}
                        colId="cliente_id"
                        {...{register, setValue, getValues}}
                        registerOptions={{required:true}}
                        callbackSuccess={() => {
                            let el = document.getElementById('error-cliente-id');
                            if (el)
                                el.style.display= 'none';
                        }}
                        callbackBlank={() => {
                            let el = document.getElementById('error-cliente-id');
                            if (el)
                                el.style.display= 'inline-block';
                        }}
                        colNombre="nombre_razon_social">
                    </MaoBuscador>
                </Col>
                {errors.cliente_id?.type === 'required' && <Col className="validacion error" id="error-cliente-id"><p role="alert">Cliente es requerido.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Descuentos
                </Form.Label>
                <Col xs="4" sm="2">
                    <Form.Control 
                        id="descuento1_porc" 
                        {...register("descuento1_porc", {onChange: (e) => {updateItemToUpdateTotals()}, min:0})}
                        type="number" htmlSize="11" />
                    {errors.descuento1_porc?.type === 'min' && <span className="validacion error" id="error-descuento1-porc">Descuento no menor a 0.</span>}
                </Col>
                <Col xs="4" sm="2">
                    <Form.Control 
                        id="descuento2_porc" 
                        {...register("descuento2_porc", {onChange: (e) => {updateItemToUpdateTotals()}, min:0})}
                        type="number" htmlSize="11" />
                    {errors.descuento2_porc?.type === 'min' && <span className="validacion error" id="error-descuento2-porc">Descuento no menor a 0.</span>}
                </Col>
                <Col xs="4" sm="2">
                    <Form.Control 
                        id="descuento3_porc" 
                        {...register("descuento3_porc", {onChange: (e) => {updateItemToUpdateTotals()}, min:0})}
                        type="number" htmlSize="11" />
                    {errors.descuento3_porc?.type === 'min' && <span className="validacion error" id="error-descuento3-porc">Descuento no menor a 0.</span>}
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3 d-none d-sm-flex">
                <Form.Label column sm="2">
                    Comisión (%)
                </Form.Label>
                <Col sm="2">
                    <Form.Control 
                        id="comision_porc" 
                        {...register("comision_porc", {onChange: (e) => {updateItemToUpdateTotals()}, min:0})}
                        type="number" htmlSize="11" />
                    {errors.comision_porc?.type === 'min' && <span className="validacion error" id="error-comision-porc">Comisión no menor a 0.</span>}
                </Col>
                <Form.Label column sm="2">
                    Cot. USD
                </Form.Label>
                <Col sm="2">
                    <Form.Control 
                        id="cotizacion_usd" 
                        {...register("cotizacion_usd", {required:true})}
                        type="number" htmlSize="11" />
                </Col>
                {errors.cotizacion_usd?.type === 'required' && <Col className="validacion error" id="error-cotizacion-id"><p role="alert">Cotizacion en USD es requerida.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3 d-sm-none">
                <Col xs="4" sm="2">
                    <Form.Label>
                        Comisión (%)
                    </Form.Label>
                    {window.innerWidth>=576?<></>:<Form.Control 
                        id="comision_porc" 
                        {...register("comision_porc", {onChange: (e) => {updateItemToUpdateTotals()}})}
                    type="number" htmlSize="11" />}
                    {errors.comision_porc?.type === 'min' && <span className="validacion error" id="error-comision-porc">Comisión no menor a 0.</span>}
                </Col>
                <Col xs="4" sm="2">
                    <Form.Label>
                        Cot. USD
                    </Form.Label>
                    {window.innerWidth>=576?<></>:<Form.Control 
                        id="cotizacion_usd" 
                        {...register("cotizacion_usd", {required:true})}
                        type="number" htmlSize="11" />}
                </Col>
                {errors.cotizacion_usd?.type === 'required' && <Col className="validacion error" id="error-cotizacion-id"><p role="alert">Cotizacion en USD es requerida.</p></Col>}
                <Col xs="4" className="d-sm-none">

                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Nota
                </Form.Label>
                <Col sm="8">
                    <Form.Control as="textarea" rows={2}
                        id="nota" {...register("nota")} />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Detalles del pedido
                </Form.Label>
                <Col sm="8">
                    <Table striped bordered hover responsive variant="dark" size="sm">
                        <thead>
                        <tr>
                            <th className="col-izquierda">Producto</th>
                            <th className="col-importe">Precio Unitario</th>
                            <th>Cant.</th>
                            <th className="col-importe">Subtotal</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {fields.map((item, index) => (
                        <tr key={item.id}>
                            <td>
                            <Form.Control 
                                {...register(`detalles.${index}.producto_id`)}
                                type="hidden" 
                                disabled={true}/>
                                <div style={{minWidth: 15+'em'}} className="col-izquierda">{item.producto}</div>
                            </td>
                            <td>
                            <Form.Control 
                                {...register(`detalles.${index}.precio_unitario`)}
                                type="hidden" htmlSize="15"
                                disabled={true} />
                            <Form.Control 
                                {...register(`detalles.${index}.precio_x_bulto`)}
                                type="hidden" htmlSize="15"
                                disabled={true} />
                                <div style={{minWidth: 8+'em'}} className="col-importe">$ {formatNumber(item.precio_unitario)}</div>
                            </td>
                            <td>
                            <Form.Control 
                                {...register(`detalles.${index}.cantidad_x_bulto`)}
                                type="hidden" htmlSize="15"
                                disabled={true} />
                            <Form.Control 
                                {...register(`detalles.${index}.cantidad`, {
                                    validate: value => {return true},
                                    onChange: (e) => {actualizarSubtotal(e.target.value,`${index}`);},
                                    /*required: true,*/
                                    min:1
                                })}
                                style={{minWidth: 4+'em'}}
                                step={`${item.cantidad_x_bulto}`}
                                type="number" htmlSize="6" /*min="1"*/ />
                                {errors.detalles?.[index]?.cantidad?.type === 'min' && (
                                  <span className="validacion error">Mayor a 0.</span>
                                )}
                            </td>
                            <td>
                                <Form.Control 
                                    {...register(`detalles.${index}.subtotal`)}
                                    type="hidden" htmlSize="15"
                                    style={{minWidth: 8+'em'}}
                                    disabled={true} />
                                <div style={{minWidth: 8+'em'}} className="col-importe">$ {formatNumber(item.subtotal)}</div>
                            </td>
                            <td>
                                <Button variant="primary" size="sm" title="Quitar" onClick={() => {hacerVisible(item.producto_id);remove(index);calcularTotales()}}>
                                    <BsFillXCircleFill/>
                                </Button>
                            </td>
                        </tr>
                        ))}
                        </tbody>
                        <tfoot>
                            {fields.length>0?
                            <>
                            <tr>
                                <td colSpan={2}>
                                </td>
                                <th className="col-importe">
                                <Form.Label >
                                    Subtotal
                                </Form.Label>
                                </th>
                                <td>
                                    <Form.Control 
                                        {...register('total_sin_desc')}
                                        type="hidden" htmlSize="15"
                                        style={{minWidth: 8+'em'}}
                                        disabled={true} />
                                    <div className="col-importe">$ {formatNumber(getValues('total_sin_desc'))}</div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                </td>
                                <th className="col-importe">
                                <Form.Label>
                                    Descuento
                                </Form.Label>
                                </th>
                                <td>
                                    <Form.Control 
                                        {...register('descuento')}
                                        type="hidden" htmlSize="15"
                                        style={{minWidth: 8+'em'}}
                                        disabled={true} />
                                    <div className="col-importe">$ {formatNumber(getValues('descuento'))}</div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                </td>
                                <th className="col-importe">
                                <Form.Label>
                                    Total
                                </Form.Label>
                                </th>
                                <td>
                                    <Form.Control 
                                        {...register('total')}
                                        type="hidden" htmlSize="15"
                                        style={{minWidth: 8+'em'}}
                                        disabled={true} />
                                    <div className="col-importe">$ {formatNumber(getValues('total'))}</div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                </td>
                                <th className="col-importe">
                                <Form.Label>
                                    Comisión
                                </Form.Label>
                                </th>
                                <td>
                                    <Form.Control 
                                        {...register('comision')}
                                        type="hidden" htmlSize="15"
                                        style={{minWidth: 8+'em'}}
                                        disabled={true} />
                                    <div className="col-importe">$ {formatNumber(getValues('comision'))}</div>
                                </td>
                                <td></td>
                            </tr>
                            </>:<></>}
                            <tr>
                                <td colSpan={5} style={{textAlign:'left'}}>
                                <Button variant="secondary" 
                                        onClick={seleccionarProductos}>
                                    Seleccionar
                                </Button>
                                <Button variant="secondary" 
                                        onClick={agregarTodos}>
                                    Añadir Todos
                                </Button>
                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Col>
                    <Form.Control 
                        id="estado" 
                        {...register("estado")}
                        defaultValue={'P'}
                        type="hidden" />
                    <Button onClick={(e) => beforeSubmit(e)} type="submit"
                            id="btnGuardar"
                            title="Se guarda quedando pendiente.">Guardar</Button>
                    {(getValues('pedido_id') && estadoInicial==='F')?<></>:
                    <Button onClick={(e) => beforeSubmit(e)} type="submit"
                            id="btnFinalizar"
                            title="Se finaliza el pedido.">Finalizar</Button>}
                    <Button variant="secondary" onClick={cancelar}>Cancelar</Button>
                </Col>
            </Form.Group>
        </Form>
        {cargando?<Cargando></Cargando>:<></>}
        <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton style={{backgroundColor: '#212529', color: 'white'}}>
          <Modal.Title>Selección de Productos</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{backgroundColor: '#212529'}}>
            <Row className="align-items-center">
                <Col xs="10" md="6">
                    <InputGroup className="mb-2">
                    <Form.Control
                        id="txtFiltroProducto" 
                        type="text"
                        onChange={(e) => {setFiltroProducto(e.target.value)}}
                        placeholder="Buscar por código o descripción"
                    />
                    <Button variant="primary" onClick={aceptarSeleccion}>
                        Aceptar
                    </Button>
                    </InputGroup>
                </Col>
                <Col xs="2" md="6">
                    
                </Col>
            </Row>
            <Table striped bordered hover responsive variant="dark" size="sm">
                <thead>
                    <tr>
                        <th>Sel.</th>
                        <th>Código</th>
                        <th>Descripción</th>
                        <th className="col-importe">Precio</th>
                        <th className="col-importe" style={{width:7+'em'}}>Cantidad</th>
                    </tr>
                </thead>
                <tbody>
                {productos.filter((p) => p.visible && (p.codigo.toLowerCase().includes(filtroProducto.toLowerCase()) || p.descripcion.toLowerCase().includes(filtroProducto.toLocaleLowerCase())))
                        .map((p,index) => <tr key={index} style={{padding: 0}}>
                    <td>
                        <Form.Check
                            type="checkbox"
                            id={`chkProductoSelected[${index}]`}
                            dataId={`${p.id}`}
                            checked={p.selected}
                            className="mb-2"
                            label=""
                            onChange={(e) => {selectProductoById(`${p.codigo}`,e.target.checked)}}
                        />
                    </td>
                    <td>{p.codigo}</td>
                    <td>{p.descripcion}</td>
                    <td className="col-importe" style={{width:9+'em'}}>
                        <Form.Control 
                                id={`precioProductoSelected[${index}]`}
                                defaultValue={p.precio_unitario}
                                style={{minWidth: 8+'em',maxWidth: 8+'em'}}
                                type="number" htmlSize="8" /*min="1"*/ 
                                onChange={(e) => {selectProductoYPrecioUnitarioById(`${p.codigo}`,e.target.value)}}
                        />
                    </td>
                    <td className="col-importe" style={{width:7+'em'}}>
                        <Form.Control 
                                id={`cantProductoSelected[${index}]`}
                                defaultValue={p.cantidad_selected}
                                style={{minWidth: 6+'em',maxWidth: 6+'em'}}
                                step={`${p.cantidad_x_bulto}`}
                                type="number" htmlSize="6" /*min="1"*/ 
                                onChange={(e) => {selectProductoYCantidadById(`${p.codigo}`,e.target.value)}}
                        />
                    </td>
                </tr>)}
                </tbody>
            </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#212529'}}>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={aceptarSeleccion}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModalGuardar.showModal} onHide={handleCloseGuardar} size="lg">
        <Modal.Header closeButton style={{backgroundColor: '#212529', color: 'white'}}>
          <Modal.Title>{showModalGuardar.mensaje}</Modal.Title>
        </Modal.Header>
        <Modal.Footer style={{backgroundColor: '#212529'}}>
          <Button variant="secondary" onClick={handleCloseGuardar}>
            Volver
          </Button>
          <Button variant="primary" onClick={() => descargar(showModalGuardar.uuid)}>
            Descargar
          </Button>
          {showModalGuardar.estado=='F'?
          <Button variant="primary" onClick={() => avisarPorTelefono(showModalGuardar.uuid, showModalGuardar.cliente_id)}>
            Compartir <FaWhatsapp />
          </Button>:<></>}
        </Modal.Footer>
       </Modal>
    </>
}